/* template */
<template minapp="mpx" xlang="wxml"><div class="error"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/e3fgOAxwky1653462896827.png" class="error-img"/><span v-for="(item, index) in (errorMsg)" class="error-text">{{ item }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md6a94956"}'>
  .error
    display flex
    flex-direction column
    align-items center
    background-color #F3F4F5
  .error-img
    margin-top 120px
    margin-bottom 17px
    width 100px
    height 100px
  .error-text
    font-weight 400
    font-size 14px
    color #333333
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md6a94956"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexd6a94956%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexd6a94956%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md6a94956"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexd6a94956/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
